module.exports = __webpack_public_path__ + "static/media/logo.0e474eab.svg";